import { ProfilePageLayout } from '@modules/_shared/components/ProfilePageLayout';
import { useLocale } from '@shared/hooks/locale';

export const TakedownAgency = () => {
  const { t } = useLocale();
  return (
    <ProfilePageLayout
      intent="takedown"
      target="agency"
      title={t('Want to remove your agency?')}
      ctaLabel={t('Claim my agency instead')}
      description={t(
        'Before you go: homeowners already see your agency on RealAdvisor. Claim it for free instead and decide what they see.',
      )}
    />
  );
};
